import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpireTag} from '@tisa-group/models';

@Injectable()
export class TagService implements CrudService<UmpireTag> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireTag[]>> {
    return this.http
      .get(`/tags`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/tags/${id}`, {params: objectToHttpParams(params)});
  }

  create(
    body: Partial<UmpireTag>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTag>> {
    return this.http
      .post<JsonApiResponse<UmpireTag>>('/tags', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireTag>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTag>> {
    return this.http
      .patch<JsonApiResponse<UmpireTag>>(`/tags/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTag>> {
    return this.http
      .get(`/tags/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }
}
